"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tool = require("../tool");
/**
 * A `Layer` represents a SVG `g` element.
 */
var Layer = /** @class */ (function () {
    function Layer(id, classes) {
        this.id = id;
        this.classes = classes;
    }
    /**
     * Render the layer
     */
    Layer.prototype.renderer = function (r) {
        this._renderer = r;
    };
    Layer.prototype.render = function (size, data, op, visualizer) {
        // group exists and is in dom?
        if (this.group && visualizer.svg.node().contains(this.group.node())) {
            this.group.html("");
        }
        else {
            this.group = visualizer.svg.append("g")
                .attr("class", this.classes.join(" ") + " bvd3-layer");
        }
        // position
        this.group.attr("transform", tool.translateFromPadding(size[this.id]));
        // render
        this._renderer.call(this.group, size, data, op, visualizer);
    };
    Layer.prototype.reposition = function (size, visualizer) {
        this.group.attr("transform", tool.translateFromPadding(size[this.id]));
    };
    Layer.prototype.invoke = function (fn) {
        fn(this.group);
    };
    return Layer;
}());
exports.Layer = Layer;
//# sourceMappingURL=layer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/legacy/layer.js
// module id = 1193
// module chunks = 0 1